import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUser } from "../../../services/userService";

export default function useDeleteUserMutation(accountHolderCode: string) {
  const queryClient = useQueryClient();
  return useMutation<string, Error, string>((id: string) => deleteUser(id), {
    onSuccess() {
      queryClient.invalidateQueries(["userDetails", accountHolderCode]);
    },
  });
}
